"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ciserano": {
    "a068f7e4": [{
      "hkey": "fcf9716e",
      "slug": "ciserano",
      "name": "Ciserano",
      "primary": true,
      "skipSearch": false
    }],
    "casinecc": [{
      "hkey": "fcf9716e",
      "slug": "ciserano",
      "name": "Ciserano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9987a4ec": [{
      "hkey": "fcf9716e",
      "slug": "ciserano",
      "name": "Ciserano",
      "primary": true,
      "skipSearch": false
    }],
    "fornas": [{
      "hkey": "fcf9716e",
      "slug": "ciserano",
      "name": "Ciserano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "74c955c8": [{
      "hkey": "fcf9716e",
      "slug": "ciserano",
      "name": "Ciserano",
      "primary": true,
      "skipSearch": false
    }],
    "la-sita": [{
      "hkey": "fcf9716e",
      "slug": "ciserano",
      "name": "Ciserano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3fda858c": [{
      "hkey": "fcf9716e",
      "slug": "ciserano",
      "name": "Ciserano",
      "primary": true,
      "skipSearch": false
    }],
    "maser": [{
      "hkey": "fcf9716e",
      "slug": "ciserano",
      "name": "Ciserano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1b4389e3": [{
      "hkey": "fcf9716e",
      "slug": "ciserano",
      "name": "Ciserano",
      "primary": true,
      "skipSearch": false
    }],
    "zingonia": [{
      "hkey": "fcf9716e",
      "slug": "ciserano",
      "name": "Ciserano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;